import Todo from './Todo'
import Footer from './Footer'
import { useEffect, useState } from 'react'
import classes from './App.module.css'


function App() {

  const [isLoading,isLoaded] = useState(true);
  const [adviceData,setAdvicedata] = useState([]);
  useEffect(()=>{
    fetch('https://api.adviceslip.com/advice').then(
      (Response)=>{
        return Response.json();
      }
    ).then((data)=>{
      const tempData = [];
      for(let key in data){
        let temp = {
          id:key,
          ...data[key]
        };
        tempData.push(temp);
      }
      setAdvicedata(tempData);
      isLoaded(false);
    })
  },[isLoading]);

  if(isLoading){
    return <><p className={classes.loading}>Loading....</p></>;
  }else{
  return (
   <>
    <Todo Advice={adviceData}/>         
    <Footer />    
   </>
  );
  }
}

export default App;